import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { Logo } from "../components/Logo";
import { Button } from "../components/ui/button";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (["expired", "failed"].includes(data.payment_status)) { setStatus("error"); return; }
      } catch { /* keep polling */ }
      if (tries++ < 10) setTimeout(poll, 1800); else setStatus("timeout");
    };
    poll();
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-brand-sand flex items-center justify-center px-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-xl p-10 text-center">
        <Link to="/" className="inline-block mb-6"><Logo className="justify-center" /></Link>
        {status === "checking" && <><Loader2 className="w-12 h-12 text-brand-cerulean mx-auto animate-spin" /><h1 className="font-serif text-2xl text-brand-navy mt-4">Confirming your deposit…</h1></>}
        {status === "paid" && <>
          <CheckCircle2 className="w-14 h-14 text-brand-emerald mx-auto" data-testid="payment-success-icon" />
          <h1 className="font-serif text-2xl text-brand-navy mt-4">Booking Confirmed!</h1>
          <p className="text-brand-slate mt-2">Your deposit is received and your appointment is secured. A confirmation email is on its way. We'll send a payment link for the remaining balance before your appointment.</p>
        </>}
        {(status === "error" || status === "timeout") && <>
          <XCircle className="w-14 h-14 text-brand-coral mx-auto" />
          <h1 className="font-serif text-2xl text-brand-navy mt-4">{status === "timeout" ? "Still processing" : "Payment issue"}</h1>
          <p className="text-brand-slate mt-2">If you completed payment, it may take a moment to reflect. Contact us if this persists.</p>
        </>}
        <Button asChild className="mt-6 bg-brand-cerulean text-white rounded-full px-8"><Link to="/" data-testid="payment-home-btn">Back to Home</Link></Button>
      </div>
    </div>
  );
}

export function PaymentCancel() {
  return (
    <div className="min-h-screen bg-brand-sand flex items-center justify-center px-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-xl p-10 text-center">
        <Link to="/" className="inline-block mb-6"><Logo className="justify-center" /></Link>
        <XCircle className="w-14 h-14 text-brand-slate mx-auto" />
        <h1 className="font-serif text-2xl text-brand-navy mt-4">Checkout Canceled</h1>
        <p className="text-brand-slate mt-2">No worries — your booking wasn't charged. You can book again anytime.</p>
        <Button asChild className="mt-6 bg-brand-cerulean text-white rounded-full px-8"><Link to="/">Back to Home</Link></Button>
      </div>
    </div>
  );
}
